import { IProfile } from "types/Profile";

export const TALK_TO_SALES_BASE_URL =
  "https://calendly.com/d/cn2f-7f9-fs8/talk-to-sales";

/**
 * Build the Talk-to-Sales (Calendly) URL pre-filled with the user's name,
 * email, and team id. Returns an empty string when the profile is not yet
 * loaded so callers can disable the CTA until data arrives.
 *
 * `a2` is Calendly's third UTM-style slot — used as `team_id` on our side.
 */
export const buildTalkToSalesUrl = (profile?: IProfile | null): string => {
  if (!profile) return "";
  const params = new URLSearchParams({
    name: `${profile.first_name ?? ""} ${profile.last_name ?? ""}`.trim(),
    email: profile.eff_email ?? "",
    a2: profile.team_id?.toString() ?? "",
  });
  return `${TALK_TO_SALES_BASE_URL}?${params.toString()}`;
};
